document.addEventListener('DOMContentLoaded', () => {
  const $header = document.querySelector('.header-wrapper');
  const $headerContainer = document.querySelector('#shopify-section-header');
  const $openCart = $header.querySelector('.js-cart-toggle');
  const $openMenu = $header.querySelector('.js-menu-toggle');
  const $closeMenu = $header.querySelector('.js-menu-close-button');
  const $searchDrawer = document.querySelector('.js-search-drawer');

  $openCart.addEventListener('click', () => {
    document.dispatchEvent(new CustomEvent('nova:cart:open'));
  });

  $openMenu.addEventListener('click', () => {
    // Close search drawer if open
    if ($searchDrawer && $searchDrawer.hasAttribute('open')) {
      $searchDrawer.hide();
    }

    $headerContainer.classList.add('menu-open');
    // Update aria-expanded
    $openMenu.setAttribute('aria-expanded', 'true');
    $closeMenu.setAttribute('aria-expanded', 'true');

    document.dispatchEvent(new CustomEvent('nova:mobile-menu:open'));
  });

  $closeMenu.addEventListener('click', () => {
    handleMenuIconClose();
    document.dispatchEvent(new CustomEvent('nova:mobile-menu:close'));
  });

  document.addEventListener('nova:menu:closed-in-modal', () =>
    handleMenuIconClose()
  );

  document.addEventListener('nova:cart:focus-last-element', () => {});

  const handleMenuIconClose = () => {
    $headerContainer.classList.remove('menu-open');
    // Update aria-expanded
    $openMenu.setAttribute('aria-expanded', 'false');
    $closeMenu.setAttribute('aria-expanded', 'false');
  };

  // Check if URL has cart=true parameter
  const urlParams = new URLSearchParams(window.location.search);
  const cartParam = urlParams.get('cart');
  if (cartParam) {
    document.dispatchEvent(new CustomEvent('nova:cart:open'));
  }
});
